
import { Vue, Component } from "vue-property-decorator";
import { IUserByMu } from "@/contants/current.ts";
import { PhoneRegExp,EmailRegExp } from "@/contants/regExp";

@Component
export default class Invoice extends Vue {
  private m: any;
  private muid: number = 0;
  private isSubmit: boolean = false;
  private isRequired: boolean = false;
  private reqTel: boolean = true;
  private ruleForm: any = {
    type: "增值税普通发票",
    invtitle: "",
    invconder: "",
    invbank: "",
    invbanknum: "",
    invaddress: "",
    username: "",
    userphone: "",
    invphone: "",
    mailingaddress: "",
  };

  private rules: any = {
    type: [
      {
        required: true,
        validator: this.handleInvoiceType,
        trigger: "change",
      },
    ],
    invtitle: [
      {
        required: true,
        message: "请填写发票抬头",
        validator: this.validateReq,
        trigger: "blue",
      },
    ],
    invconder: [
      {
        required: true,
        message: "请填写纳税人识别号/统一社会信用代码",
        validator: this.validateReq,
        trigger: "blue",
      },
    ],
    invbank: [
      {
		required: true,
        message: "请填写开户银行",
        trigger: "blue",
      },
    ],
    invbanknum: [
      {
		required: true,
        message: "请填写银行账户",
        trigger: "blue",
      },
    ],
    invaddress: [
      {
		required: true,
        message: "请填写注册地址",
        trigger: "blue",
      },
    ],
    invphone: [
      {
		required: true,
        message: "请填写正确的手机号码",
        validator: this.validateReq,
        trigger: "blue",
      },
    ],
    username: [
      {
        message: "请填写联系人姓名",
        validator: this.validateReq,
        trigger: "blue",
      },
    ],
    userphone: [
      {
        message: "请填写正确的手机号码",
        validator: this.validateReq,
        trigger: "blue",
      },
    ],
    mailingaddress: [
      {
		required: true,
        message: "请填写发票接收邮箱",
        validator: this.validateEmail,
        trigger: "blue",
      },
    ],
  };

  created() {
    this.m = Number(this.$route.query.m);
    this.GetSignMeetingUserByMu();
  }

  /**
   * @description:选择发票类型时的检验规则
   */
  handleInvoiceType(rule: any, value: any, callback: any) {
    this.isRequired = Boolean(Number(this.ruleForm.type));
  }
  /**
   * @description:必选项为空时，提示
   */
  validateReq(rule: any, value: any, callback: any) {
    if (this.isRequired) {
      rule.required = this.isRequired;
    }
    /**if (rule.field === "invphone" || rule.field === "userphone") {
      if (Number(value)) {
        console.log(typeof value);
      }
      // if (Number(value)) {
      console.log(Number(value), value, PhoneRegExp.test(String(value)));
      if (value && !PhoneRegExp.test(String(value))) {
        this.reqTel = false;
        callback(new Error("llll"));
      } else {
        this.reqTel = true;
      }
      // }
    }*/
    if (rule.required && !value) {
      callback(new Error(rule.message));
    } else {
      callback();
    }
  }
	validateEmail(rule: any, value: any, callback: any) {
		if (!value) {
		  callback(new Error(rule.message));
		} else if (!EmailRegExp.test(String(value))) {
			debugger
		  callback('请输入正确的接收邮箱');
		}else {
		  callback();
		}
	}
  /**
   * @description: 获取当前登录账户报名信息
   */
  async GetSignMeetingUserByMu() {
    let params = {
      m: this.m,
    };
    let res = await IUserByMu.GetSignMeetingUserByMu(params);
    if (res.Code === 1000) {
      let { muid } = res.CurUserEntity;
      this.muid = Number(muid);
      this.handleInitSignUpInvoice();
    }
  }
  /**
   * @description: 获取发票信息
   */
  async handleInitSignUpInvoice() {
    let params = {
      m: this.m,
      muid: this.muid,
    };
    let _res = await this.$http.personalCenter.InitSignUpInvoice(params);

    if (_res.Code === 1000) {
      // this.ruleForm = _res;
      // this.ruleForm.type = _res.invtype ? "增值税专用发票" : "增值税普通发票";
      this.ruleForm = {};
      let {
        invtitle,
        invconder,
        invbank,
        invbanknum,
        invaddress,
      } = _res;
      this.ruleForm = {
        type: "增值税普通发票",
        invtitle,
        invconder,
        invbank,
        invbanknum,
        invaddress,
      };
    }
    console.log("res", _res, this.ruleForm);
  }

  /**
   * @description:提交
   */
  async submitForm(formName: any) {
    (this.$refs[formName] as any).validate((valid: any) => {});
    //判断必填项是否为空
    let _ruleForm = [];

    for (let i in this.ruleForm) {
      if (this.isRequired  || this.rules[i][0].required) {
        _ruleForm.push(this.ruleForm[i]);
      }
    }
    console.log(this.ruleForm)
    console.log(_ruleForm)

    this.isSubmit = _ruleForm.every(item => {
      return item !== "";
    });

    console.log(this.reqTel, "isSubmit", this.isSubmit);
    if (this.isSubmit && this.reqTel) {
      let parmes = this.ruleForm;
      parmes.m = this.m;
      parmes.muid = this.muid;
      let Res = await this.$http.personalCenter.EditUserInvoice(parmes);
      console.log("Res", Res);
      if (Res.Code === 1000) {
        this.$message({ message: "修改成功", type: "success" });
        setTimeout(() => {
          this.$router.go(0);
        }, 1000);
      }
    }
  }
}
